import { Emitter, EmitterConfig, OldEmitterConfig, Particle, ParticleUtils } from "pixi-particles";
import { Container, DisplayObject, Point } from "pixi.js";

export class EmitterOrbit extends Emitter {
    orbitVelocity: number;
    rot45: boolean = true;

    constructor(particleParent: Container<DisplayObject>, particleImages: any, config: EmitterConfig | OldEmitterConfig) {
        super(particleParent, particleImages, config);
        this.orbitVelocity = 0;
    }

    override update(delta: number): void {
        super.update(delta);
        if (this.orbitVelocity != 0) {
            let next;
            let particle;
            const emitterPos = this.spawnPos;
            for (particle = this._activeParticlesFirst; particle; particle = next) {
                const dx = particle.x - emitterPos.y;
                const dy = particle.y - emitterPos.y;
                const point = new Point(dx, dy);
                const r = Math.sqrt(dx * dx + dy * dy);
                const angleDelta = this.orbitVelocity * delta / r;
                ParticleUtils.rotatePoint(angleDelta, point);
                ParticleUtils.rotatePoint(angleDelta, particle.velocity);
                particle.x = point.x + emitterPos.x;
                particle.y = point.y + emitterPos.y;
                next = particle.next;
                if (this.noRotation && this.rot45) {
                    particle.angle = 45;
                }
            }
        }
    }
}